import {observable} from "mobx";
import {ParamTable} from "../domain/tenantDomain";
import mdAxios from "../../common/config/axios-config";
import {IDomainObject} from "../../form/formUtils";
import {ID} from "../../metamodel/metaConstant";
import {LovItem} from "../../metamodel/mdEntity";
import {EditTenantDto} from "../../common/domain/EditableTenantAncestor";

class TenantService {

  @observable public paramTableObject: ParamTable;

  readParamTableRow(paramTableId: string): Promise<ParamTable> {
    return mdAxios.get(`/core/param-table/${paramTableId}`)
      .then(res => new ParamTable(res.data));
  }

  saveParamTable(paramTable: EditTenantDto<ParamTable>, isNew: boolean): Promise<IDomainObject> {
    isNew = isNew === undefined || isNew === null ? false : isNew;
    return mdAxios.post(`/core/param-table/save?isNew=${isNew}`, paramTable, {showPrettyError: true})
      .then(res => res.data);
  }

  deleteTableParam(paramTableId: string): Promise<any> {
    return mdAxios.delete(`/core/param-table/delete/${paramTableId}`, {showPrettyError: true});
  }

  checkIfValueIsAssignableToParamKey(paramKey: LovItem<ID>, value: string): Promise<void> {
    return mdAxios.post(`/core/param-table/value-check`, {
      paramKey: paramKey,
      value: value
    }, {showPrettyError: true})
      .then(res => res.data);
  }

  getTenantLovItem(tenantId: number): Promise<LovItem> {
    return mdAxios.get(`/core/tenant/${tenantId}`, {showPrettyError: true})
      .then(res => res.data);
  }

  //GET /core/tenant/binded-tenants?entityName[]=DocumentType&DocumentTypeIds[]=1&DocumentTypeIds[]=2
  getBindedTenants(entities: string[], ids: Record<string, ID[]>) : Promise<LovItem[]> {
    return mdAxios.get(`/core/tenant/binded-tenants?`, {params: {
        entityName: entities,
        ...ids
      }})
      .then(res => res.data);
  }
}

export default new TenantService();



// WEBPACK FOOTER //
// ./src/core/tenant/service/tenantService.ts